<template>
  <div id="app">
    <nav>
      <router-link to="/"></router-link>
    </nav>
    <router-view/>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'App',
  data() {
    return {
      OSS_BASE_URL: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets',
      api: 'https://api.xjdx.top',
      isWeChat: false,
      wxReady: false
    }
  },
  mounted() {
    // 检测是否在微信环境中
    this.isWeChat = this.checkIsWeChat();
    
    // 如果在微信环境中，初始化微信分享
    if (this.isWeChat) {
      this.initWechatShare();
    }
  },
  methods: {
    // 检测是否在微信环境中
    checkIsWeChat() {
      const ua = navigator.userAgent.toLowerCase();
      return /micromessenger/.test(ua);
    },
    
    // 初始化微信分享
    async initWechatShare() {
      try {
        // 获取当前页面URL（不包含hash部分，但包含参数）
        // 注意：iOS 微信中，签名用的 URL 是第一次进入页面的 URL，不会随着 SPA 路由变化而变化
        // Android 微信中，签名用的 URL 是当前页面的 URL
        const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
        let url = isIOS && window.entryUrl ? window.entryUrl : window.location.href.split('#')[0];
        
        // 从后端获取微信签名配置
        const response = await axios.get(this.api + '/wechat/config', {
          params: { url },
          paramsSerializer: params => {
            return Object.keys(params)
              .map(key => `${key}=${encodeURIComponent(params[key])}`)
              .join('&');
          }
        });

        if (!response.data.success) {
          console.error('获取微信配置失败:', response.data.message);
          return;
        }

        const config = response.data.data;

        wx.config({
          debug: false, // 关闭调试模式
          appId: config.appId,
          timestamp: config.timestamp,
          nonceStr: config.nonceStr,
          signature: config.signature,
          jsApiList: [
            'onMenuShareAppMessage',      // 旧版分享接口（分享给朋友）
            'onMenuShareTimeline'         // 旧版分享接口（分享到朋友圈）
          ]
        });

        wx.ready(() => {
          this.wxReady = true;
          // 设置全局状态，供子组件使用
          window.wxReady = true;
          
          // iOS 需要延迟设置分享配置
          setTimeout(() => {
            // 设置默认分享内容
            this.updateWechatShare();
            
            // 监听子组件发送的分享配置更新事件
            this.$root.$on('update-wechat-share', (shareInfo) => {
              this.updateWechatShare(shareInfo);
            });
          }, 500); // 延迟 500ms，确保 iOS 微信 SDK 完全就绪
        });

        wx.error(function(res){
          console.error('微信分享初始化失败:', res);
        });
        
      } catch (error) {
        console.error('获取微信签名失败:', error);
      }
    },
    
    // 更新微信分享配置
    updateWechatShare(shareInfo) {
      if (typeof wx === 'undefined' || !this.wxReady) {
        return;
      }
      
      // 构建分享链接
      let shareLink = window.location.origin + window.location.pathname;
      
      // 如果有人物名字，添加到链接中
      if (shareInfo && shareInfo.characterName) {
        shareLink += '?character=' + encodeURIComponent(shareInfo.characterName);
      }
      
      // 构建分享数据
      const shareData = {
        title: shareInfo && shareInfo.title ? shareInfo.title : '延庆区先进典型人物事迹展览',
        desc: shareInfo && shareInfo.desc ? shareInfo.desc : '妫川脊梁·时代荣光',
        link: shareLink,
        imgUrl: this.OSS_BASE_URL + '/sharePoster2.png'
      };
      
      // 分享给朋友
      wx.onMenuShareAppMessage({
        title: shareData.title,
        desc: shareData.desc,
        link: shareData.link,
        imgUrl: shareData.imgUrl
      });
      
      // 分享到朋友圈
      wx.onMenuShareTimeline({
        title: shareData.title,
        link: shareData.link,
        imgUrl: shareData.imgUrl
      });
    }
  },
  
  beforeDestroy() {
    // 清理事件监听
    this.$root.$off('update-wechat-share');
  }
}
</script>

<style>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

#app {
  padding: 0;
}

button {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  font-size: inherit;
  font-family: inherit;
  cursor: pointer;
  outline: none;
}

/* 在现有样式中添加以下代码 */
input {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  font-size: inherit;
  font-family: inherit;
  outline: none;
  -webkit-appearance: none; /* 移除 Safari/Chrome 的默认样式 */
  -moz-appearance: none;    /* 移除 Firefox 的默认样式 */
  appearance: none;         /* 移除其他浏览器的默认样式 */
}

/* 如果需要兼容 older versions of IE */
input::-ms-clear {
  display: none;
}

/* 移除 input[type="search"] 的特殊样式 */
input[type="search"] {
  -webkit-appearance: none;
}

/* 移除 input[number] 的 spinner */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
}
</style>